import React, { useEffect } from 'react';
import { Form, DatePicker, Typography } from 'antd';
import ModalFooterButton from '../ModalFooterButton';
import { required } from '../../../constants/formValidation';


const { Paragraph } = Typography;

const HolidayForm  = ({ form, handleAddHoliday, loading }) => {
    const { getFieldDecorator, setFieldsValue } = form;

    const handleSubmit = e => {
        e.preventDefault();

        form.validateFields((err, { selectedDate }) => {
            if (err) return;

            handleAddHoliday(selectedDate.startOf('day'));
        });
    };

    useEffect(() => {
        if (loading) {
            setFieldsValue({ selectedDate: null });
        }
    }, [loading, setFieldsValue]);

    return (
        <Form onSubmit={handleSubmit}>
            <Paragraph>
                Please note, adding a holiday will prevent new bookings from being created on this date.
            </Paragraph>
            <br />
            <Form.Item>
                {
                    getFieldDecorator('selectedDate', required()) (
                        <DatePicker
                            format="DD/MM/YYYY"
                            placeholder="Select Date"
                            disabled={loading}
                        />
                    )
                }
            </Form.Item>
            <ModalFooterButton
                label="Add Holiday"
                loading={loading}
            />
        </Form>
    );
};

export default Form.create({ name: 'holiday' })(HolidayForm);
